
export default {
  SET_SIDEBAR(state, data) {
    state.menuItems = data
  }
};
